/* eslint-disable no-restricted-globals */
function dateIsValid(date) {
  return date instanceof Date && !isNaN(date);
}

export default dateIsValid;
